import { render, staticRenderFns } from "./PremiumProduct.vue?vue&type=template&id=06580dfb&scoped=true&"
import script from "./PremiumProduct.vue?vue&type=script&lang=js&"
export * from "./PremiumProduct.vue?vue&type=script&lang=js&"
import style0 from "./PremiumProduct.vue?vue&type=style&index=0&id=06580dfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06580dfb",
  null
  
)

export default component.exports